import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{staticClass:"container",attrs:{"cols":"auto"}},[_c(VCard,{staticClass:"elevation-12 d-flex card",attrs:{"color":"primary"}},[_c('div',{staticClass:"image"},[_c('img',{attrs:{"src":_vm.logos.login}})]),_c('div',{staticClass:"login"},[_c('div',{staticClass:"logo mb-5"},[_c('img',{staticClass:"logoImg",attrs:{"src":_vm.logos.logo}})]),_c('login-form'),_c('div',{staticClass:"texts-footer"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n      ")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }